import { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles.css';

import { API_URL } from '../config';

function Questions() {
  const [answers, setAnswers] = useState([]);
  const [error, setError] = useState('');
  const [deleteStatus, setDeleteStatus] = useState({});

  useEffect(() => {
    const fetchAnswers = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setError('Please log in.');
          window.location.href = '/login';
          return;
        }
        const response = await axios.get(`${API_URL}/api/answers`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setAnswers(response.data);
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to fetch answers.');
        window.location.href = '/login';
      }
    };
    fetchAnswers();
  }, []); // Removed navigate dependency

  const handleDeleteAnswer = async (answerId) => {
    if (!window.confirm('Are you sure you want to delete this answer?')) {
      return;
    }
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/api/answer/${answerId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAnswers(answers.filter((answer) => answer.answer_id !== answerId));
      setDeleteStatus((prev) => ({
        ...prev,
        [answerId]: 'Deleted!',
      }));
      setTimeout(() => {
        setDeleteStatus((prev) => ({
          ...prev,
          [answerId]: '',
        }));
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to delete answer.');
    }
  };

  return (
    <div className="container">
      {/* Navigation */}
      <nav className="dashboard-nav">
        <button onClick={() => window.location.href = '/dashboard'}>Dashboard</button>
        <button onClick={() => window.location.href = '/question-of-the-day'}>Question of the Day</button>
        <button onClick={() => window.location.href = '/ai-assistant'}>AI Assistant</button>
        <button onClick={() => {
          localStorage.removeItem('token');
          window.location.href = '/login';
        }}>
          Logout
        </button>
      </nav>

      <h1>Question History</h1>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      
      {answers.length > 0 ? (
        <div className="answers-list">
          {answers.map((answer) => (
            <div key={answer.answer_id} className="answer-item" style={{
              border: '1px solid #ddd',
              padding: '20px',
              marginBottom: '20px',
              borderRadius: '8px',
              backgroundColor: '#f9f9f9'
            }}>
              <p><strong>Question ID: {answer.question_id}</strong></p>
              <h3 style={{ color: '#333', marginBottom: '10px' }}>
                {answer.question_text}
              </h3>
              <p style={{ marginBottom: '15px', lineHeight: '1.5' }}>
                <strong>Answer:</strong> {answer.answer_text}
              </p>
              <p style={{ color: '#666', marginBottom: '15px' }}>
                <strong>Answered on:</strong> {new Date(answer.created_at).toLocaleString()}
              </p>
              <button 
                onClick={() => handleDeleteAnswer(answer.answer_id)}
                className="danger-button"
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#dc3545',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
              >
                Delete Answer
              </button>
              {deleteStatus[answer.answer_id] && (
                <span style={{ color: 'green', marginLeft: '10px' }}>
                  {deleteStatus[answer.answer_id]}
                </span>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p>No answers yet. Start by answering some questions!</p>
      )}
      
      <button 
        onClick={() => window.location.href = '/dashboard'}
        style={{
          padding: '10px 20px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          marginTop: '20px'
        }}
      >
        Back to Dashboard
      </button>
    </div>
  );
}

export default Questions;